import React, { useEffect, useState} from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './pitapit.css';
import Pitapit from './pitapit';
import {pollImpact} from '../common/api/impactPoller';
import ImpactPage from './public-impact/ImpactPage';

function App() {

  const [fetchedImpact, setFetchedImpact] = useState(null);
  const merchantCode = "BES_NZ_PITA_PIT";
  useEffect(() => {
    pollImpact(setFetchedImpact,merchantCode);
  }, []);

  return (
    <>
      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-pitapit-impact"
        >
          <ImpactPage fetchedImpact={fetchedImpact}/>
        </Route>  
        <Route
          path={`/`}
          key="app-entry-pitapit"
        >
          <Pitapit merchantCode={merchantCode} fetchedImpact={fetchedImpact}/>
        </Route>
      </Switch>
    </>
  );
}

export default App;
